/**
 * 数字加千位符
 * @param {*} num 数字
 * @param {*} precision 保留的小数位数
 *
 * 测试:
 * console.log(thousandsFormat(569875.206, 2))   // 569,875.21
 * console.log(thousandsFormat(569875.206, 0))   // 569,875
 * console.log(thousandsFormat('569875.206', 6))   // 569,875.206000
 * console.log(thousandsFormat('sd222', 2))   // sd222
 * console.log(thousandsFormat('', 2))   // ''
 */

const qianfen = (num, precision = 0) => {
    num = isNaN(parseFloat(num)) ? num : parseFloat(num)
    num = (num.toFixed ? num.toFixed(precision) : num) + ''
    if (!num.includes('.')) num += '.'
    return num
        .replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
            return $1 + ','
        })
        .replace(/\.$/, '')
}

/**
 * 去掉html标签 <span>a</span> -> a
 */
const formatHtml = (html) => {
    if (!html) {
        return ''
    }
    return html.replace(/<\/?[^>]+>/g, '')
}
/**
 * 遇() 换行
 */
const preText = (text) => {
    const index = text.indexOf('(')
    if (index !== -1) {
        const first = text.slice(0, index)
        const last = text.slice(index)
        return `${first}\n${last}`
    }
    return text
}

/**
 * 改变请求图片大小
 */

const resizeImg = (src, w) => {
    if (src) {
        return `${src}?x-oss-process=image/resize,w_${w}`
    }
}

export default {
    qianfen,
    formatHtml,
    preText,
    resizeImg
}
